<template>
  <div class="ma-content" v-if="!loading">
    <v-row v-if="welcomeCard || whereToStartCard">
      <v-col cols="12" :md="whereToStartCard ? 6 : 12" v-if="welcomeCard"><ContentCard :card="welcomeCard" name="WelcomeCard" /></v-col>
      <v-col cols="12" :md="welcomeCard ? 6 : 12" v-if="whereToStartCard"><ContentCard :card="whereToStartCard" name="WhereToStartCard" /></v-col>
    </v-row>
    <v-row v-if="generalNewsCard || teacherNewsCard">
      <v-col cols="12" :md="teacherNewsCard ? 6 : 12" v-if="generalNewsCard"><ContentCard :card="generalNewsCard" name="GeneralNewsCard" /></v-col>
      <v-col cols="12" :md="generalNewsCard ? 6 : 12" v-if="teacherNewsCard"><ContentCard :card="teacherNewsCard" name="TeacherNewsCard" /></v-col>
    </v-row>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import ContentCard from "../../resource/card/ContentCard.vue";

export default {
  name: "TeacherHome",
  components: {ContentCard},
  computed: {
    ...mapState('dashboard', ['data']),
    loading() {
      return !this.data;
    },
    welcomeCard() {
      return this.data.cards.welcome;
    },
    whereToStartCard() {
      return this.data.cards.whereToStart;
    },
    teacherNewsCard() {
      return this.data.cards.teacherNews;
    },
    generalNewsCard() {
      return this.data.cards.musicNews;
    },
  },
  methods: {
    ...mapActions('ui', ['resetBreadcrumbs']),
    ...mapActions('dashboard', ['loadData']),
  },
}
</script>

<style lang="scss">
@import '../style';

$block-title-color: lighten($col-home, 60%);

.ma-home {
  @include withTitleBlock($col-home);
}

</style>